var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('h2',[_vm._v("Contact"),_c('br'),_vm._v(" support@waterguru.com"),_c('br'),_vm._v(" with any questions")])])
}]

export { render, staticRenderFns }